var _rect, _rect2, _g, _circle, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaTransferLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Media Transfer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    rx: 224,
    ry: 224,
    fill: "#001C36"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 512,
    rx: 224,
    ry: 224,
    fill: "#0A2847",
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(112, 96) scale(4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5 97L14 140H186.5L183 132.5L170 127L160 114L144 119.5L135 97L100 60L76 80.5V86L67 100.5L58.5 97Z",
    fill: "#FBF9F7",
    stroke: "#FBF9F7",
    strokeWidth: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 360,
    r: 54,
    fill: "#F3C055"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(512, 820)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -90,
    cy: 0,
    r: 22,
    fill: "#F3C055",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -30,
    cy: 0,
    r: 22,
    fill: "#F3C055",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 0,
    r: 22,
    fill: "#F3C055"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 0,
    r: 22,
    fill: "#FBF9F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaTransferLogo);
export default __webpack_public_path__ + "static/media/media-transfer-logo.9dfe8157191d7e2dff9f19707fab16a3.svg";
export { ForwardRef as ReactComponent };